export default "__VITE_ASSET__DRmKc2oX__"